const projectsData = [
  {
    title: "Go Car",
    description:
      "A website of a rental car company showing car models, Q&A, booking system, etc.",
    tag: ["React"],
    image: require("../projectsImage/goCar.png"),
    url: "https://car-rental-xi-gray.vercel.app/",
  },
  {
    title: "Amazon Clone",
    description:
      "An Amazon clone full stack app that allows the user to add items to the basket and checkout. ",
    tag: ["React", "Firebase", "fullstack", "Stripe"],
    image: require("../projectsImage/amz.png"),
    url: "https://github.com/Chilam-Yim/Amazon_Clone",
  },
  {
    title: "Somewhere",
    description:
      "A website to generate a city for your next vacation, providing you with cities' photo, weather information and the current time.",
    tag: ["React", "API"],
    image: require("../projectsImage/somewhere.png"),
    url: "https://somewhere-bruce-yim.vercel.app/",
  },
  {
    title: "6 Bars Clock",
    description:
      "A clock showing the current time in an interesting way with 6 bars moving.",
    tag: ["javascript"],
    image: require("../projectsImage/6clock.png"),
    url: "https://six-bars-clock.vercel.app/",
  },
  {
    title: "Taste Finder",
    description:
      "This is a simple react native group project of a food review app called 'Taste Finder'. ",
    tag: ["React Native", "MongoDB"],
    image: require("../projectsImage/tasteFinder.png"),
    url: "https://github.com/Chilam-Yim/Taste-Finder",
  },
  {
    title: "The Boss's World",
    description:
      "It is a little game of my dog printed in every side of a cube spinning in the universe.",
    tag: ["3JS"],
    image: require("../projectsImage/boss.png"),
    url: "https://boss-world.vercel.app/",
  },
  {
    title: "Location App",
    description:
      "Using Vue to create a simple application to obtain a city's time and location on the google map.",
    tag: ["Vue"],
    image: require("../projectsImage/location_app.png"),
    url: "https://github.com/Chilam-Yim/location_app",
  },
  {
    title: "Chat Online 10101",
    description:
      "An instant chat platform allows users to communicate with each other.",
    tag: ["React", "Firebase"],
    image: require("../projectsImage/chatOnline.png"),
    url: "https://github.com/Chilam-Yim/Chat-online-10101",
  },

  {
    title: "News Feed",
    description:
      "A group project of a news app brings you the latest news around the world using Bing news API.",
    tag: ["API"],
    image: require("../projectsImage/newsFeed.png"),
    url: "https://cpan144-project.vercel.app/",
  },
  {
    title: "Distribution Center",
    description:
      "This is a full-stack app developed with Java. It is a simulated system for an admin of a distribution cneter.",
    tag: ["fullstack", "SpringBoot", "API", "Postgres"],
    image: require("../projectsImage/disCenter.png"),
    url: "https://github.com/Chilam-Yim/final-project-frontend",
  },

  {
    title: "Snake Game",
    description:
      "This is a snake game created using Java, which is a desktop application featuring score count and restart function.",
    tag: ["Java"],
    image: require("../projectsImage/snake.png"),
    url: "https://github.com/Chilam-Yim/snake_game",
  },

  {
    title: "Email Application",
    description:
      "This is a simple application using Python and Django to send an email with attachment.",
    tag: ["Python", "Django"],
    image: require("../projectsImage/email.png"),
    url: "https://github.com/Chilam-Yim/network_final",
  },
  {
    title: "Current time",
    description: "An app showing the current time and fun facts.",
    tag: ["React", "API"],
    image: require("../projectsImage/current.png"),
    url: "https://current-time-sigma.vercel.app/",
  },
];

export default projectsData;
